/* Studio Ford 2026 — Shopify Forms (Trade page) styled to match the site (Josie, Oct 27 2026).
   The Forms app block renders inside an open shadow root, so theme CSS can't reach it. This adds one <style> to that shadow
   root as soon as the form renders: square corners, black button, Times New Roman at the Purchasing Terms sizes (14px uppercase
   bold heading, 13px text), single column at the full width of the copy column.
   Everything is !important because the app's own stylesheet is adopted after ours. The app's hashed class names change between
   releases, so selectors match on the stable fragment (e.g. [class*="_formSubmitButton_"]). If the app ever changes its markup the
   form just falls back to its own look; nothing breaks. Form behaviour (fields, validation, hCaptcha, submit) is untouched. */
(function () {
  'use strict';
  if (window.__sfFormsInit) return;
  window.__sfFormsInit = true;

  var CSS = [
    ':host{',
    ' --forms-body-font: normal 400 13px "Times New Roman", Times, serif !important;',
    ' --forms-heading-font: normal 700 14px "Times New Roman", Times, serif !important;',
    ' --forms-heading-font-size:14px !important; --heading-font-size:14px !important; --forms-base-font-size:13px !important;',
    ' --body-text-color:#111 !important; --heading-text-color:#111 !important; --form-text-color:#111 !important; --form-placeholder-color:#11111180 !important;',
    ' --form-field-border-radius:0 !important; --button-border-radius:0 !important; --container-border-radius:0 !important;',
    ' --form-field-border:0 1px 0 0 #11111166 !important; --form-field-border-focused:0 1px 0 0 #111 !important;',
    ' --form-field-padding:0px !important; --form-field-padding-top:14px !important; --form-field-padding-bottom:4px !important; --form-background-color:transparent !important;',
    ' --button-background-color:#111 !important; --button-text-color:#fff !important; --button-background-color-hovered-modifier:opacity(85%) !important;',
    ' --forms-accent-color:#111 !important; --link-text-color:#111 !important; --form-error-color:#9e3326 !important;',
    ' --inline-container-max-width:none !important; --container-max-w:none !important; --app-embed-padding-x:0 !important; --app-embed-padding-y:0 !important;',
    '}',
    '[class*="_formContainer_"]{display:block !important; width:100% !important; max-width:none !important; box-shadow:none !important; background:transparent !important; padding:0 2px 2px 1px !important; box-sizing:border-box !important;}',
    '[class*="_container_"],[class*="_inline_"]{grid-template-columns:minmax(0,1fr) !important; width:100% !important; max-width:none !important;}',
    '#form-container-ref{width:100% !important;}',
    '[class*="_gridItem_"][class*="_imageLoading_"]{display:none !important;}',
    '[class*="_textHeading_"]{text-transform:uppercase !important; letter-spacing:.02em !important; font-weight:700 !important; font-size:14px !important; margin:0 0 6px !important;}',
    '[class*="_textBody_"] p{font-size:13px !important; margin:0 !important;}',
    'form[class*="_formFieldset_"]{gap:2px !important; row-gap:2px !important;}',
    '[class*="_formFieldContainer_"]{height:auto !important; min-height:0 !important;}',
    '[class*="_formInputField_"]{border-radius:0 !important; font-size:13px !important; background:transparent !important; padding:14px 0 4px !important; height:auto !important; line-height:18px !important;}',
    '[class*="_formInputFieldLabel_"]{font-size:13px !important; left:0 !important; top:14px !important; line-height:18px !important;}',
    '[class*="_formFieldContainer_"]:focus-within [class*="_formInputFieldLabel_"],[class*="_inputFilled_"]{transform:translateY(-13px) scale(.8) !important;}',
    '[class*="_formSubmitButton_"]{text-transform:uppercase !important; letter-spacing:.16em !important; font-size:11px !important; padding:14px 28px !important; border:1px solid #111 !important; border-radius:0 !important; width:auto !important;}',
    '[class*="_formFileInputField_"]{border-radius:0 !important;}',
    '[class*="_formFieldContainer_"]:has([class*="_formFileInput"]){margin-top:10px !important;}',
    '[class*="_formFileInputButton_"]{border-radius:0 !important; text-transform:uppercase !important; letter-spacing:.14em !important; font-size:11px !important;}'
  ].join('\n');

  function reveal(host) { host.classList.add('is-styled'); }

  // The form's title lives in the Forms app (admin), not the theme; show "Trade" here regardless (Josie, Oct 28 2026).
  function retitle(sr) {
    var h = sr.querySelector('[class*="_textHeading_"]');
    if (h && /^to the trade$/i.test(h.textContent.trim())) h.textContent = 'Trade';
    var d = sr.querySelector('[role="dialog"][aria-label]');
    if (d && /^to the trade$/i.test(d.getAttribute('aria-label'))) d.setAttribute('aria-label', 'Trade');
  }

  function apply(host) {
    var sr = host.shadowRoot;
    if (!sr) return false;
    if (!sr.getElementById('sf-forms-style')) {
      var st = document.createElement('style');
      st.id = 'sf-forms-style';
      st.textContent = CSS;
      sr.appendChild(st);
    }
    retitle(sr);
    // the form renders after the shadow root exists (and re-renders on step changes), so keep the title right
    if (!host.__sfTitleObs && window.MutationObserver) {
      host.__sfTitleObs = new MutationObserver(function () { retitle(sr); });
      host.__sfTitleObs.observe(sr, { childList: true, subtree: true, characterData: true });
    }
    reveal(host);
    return true;
  }

  function run() {
    var hosts = document.querySelectorAll('shopify-forms-embed');
    Array.prototype.forEach.call(hosts, apply);
    return hosts.length > 0 && Array.prototype.every.call(hosts, function (h) { return !!h.shadowRoot; });
  }

  var tries = 0;
  var t = setInterval(function () {
    tries++;
    if (run() || tries > 60) {
      clearInterval(t);
      // never leave the form hidden if something went wrong
      Array.prototype.forEach.call(document.querySelectorAll('shopify-forms-embed'), reveal);
    }
  }, 150);
  document.addEventListener('DOMContentLoaded', run);
  // safety net: show the form after 3s no matter what
  setTimeout(function () { Array.prototype.forEach.call(document.querySelectorAll('shopify-forms-embed'), reveal); }, 3000);
})();
